import groq from 'groq'

export function imageAsset() {
	return groq`
    {
      "type": "image",
      "uid": _key,
      alt,
      secondaryCaption,
      hotspot,
      ...asset->{
        url,
        "width": metadata.dimensions.width,
        "height": metadata.dimensions.height,
        extension,
      }
    }
  `
}
